import optimizely, { OptimizelyDecideOption } from '@optimizely/optimizely-sdk';
import React, { createContext, useEffect, useState } from 'react';

import ENV from '../env/environment';
import { cartEvent } from '../utils/cartEvent';
import { getHash } from '../utils/hash';

// @ts-ignore
optimizely[ENV.LOG_METHOD](ENV.LOG_LEVEL);

const optimizelyClient = optimizely.createInstance({
  sdkKey: ENV.OPTIMIZELY_KEY,
});

interface FeaturesContextProps {
  features: any;
}

const FeaturesContext = createContext<Partial<FeaturesContextProps>>({});

export const FeaturesProvider: React.FC<any> = ({
  customerId,
  siteDomain,
  children,
}): JSX.Element => {
  const [features, setFeatures] = useState<any>({
    articlesHighlighted: null,
    shutdownLandingPage: null,
    shutdownSecondPhase: null,
  });
  const [optimizelyId, setOptimizelyId] = useState<string | null>(null);
  const {sidCookie} = cartEvent();

  useEffect(() => {
    if (!optimizelyId) {
      customerId ? setOptimizelyId(customerId) : setOptimizelyId(sidCookie);
    }
  }, [customerId, sidCookie]);

  useEffect(() => {
    if (optimizelyId && siteDomain && optimizelyClient) {
      Promise.all([getHash(optimizelyId), optimizelyClient.onReady()]).then(([hash]) => {
        const user = optimizelyClient.createUserContext(hash, { siteDomain });
        const articlesHighlightedFlag = user?.decide('rew-2084_highlight_promotion_on_rws', [
          OptimizelyDecideOption.INCLUDE_REASONS,
        ]);
        const shutdownLandingPageFlag = user?.decide('rew-4344_shutdown_landing_page', [
          OptimizelyDecideOption.INCLUDE_REASONS,
        ]);
        const shutdownSecondPhaseFlag = user?.decide('rew-4344_shutdown_second_phase', [
          OptimizelyDecideOption.INCLUDE_REASONS,
        ]);
        setFeatures({
          articlesHighlighted: articlesHighlightedFlag?.enabled,
          shutdownLandingPage: shutdownLandingPageFlag?.enabled,
          shutdownSecondPhase: shutdownSecondPhaseFlag?.enabled,
        });
      });
    }
  }, [optimizelyId, siteDomain]);
  return <FeaturesContext.Provider value={{ features }}>{children}</FeaturesContext.Provider>;
};
export default FeaturesContext;
